import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { generateKey } from "../../sharedfiles/helper";
import Skelton from "../Common/skeleton/Skeleton";
import { COMMON_CONSTANTS, FRAUDSCRUB_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";

const maxipHeaders = [COMMON_CONSTANTS.header_cid, COMMON_CONSTANTS.header_userName, COMMON_CONSTANTS.header_firstname, COMMON_CONSTANTS.header_lastname];
const maxipRowAccessors = [
  (item) => item.userId,
  (item) => item.userName,
  (item) => item.firstName,
  (item) => item.lastName,
];

export const MaxipDialog = (props) => {
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("fraudScrubMaxipDialog", maxipHeaders);

  return (
    <>
      <Dialog open={props.openMaxipDialog} onOpenChange={() => props.setOpenMaxipDialog(false)}>
        <DialogContent className="max-w-5xl h-[80vh] flex flex-col p-0">
          <DialogHeader className="px-6 py-4 border-b shrink-0">
            <DialogTitle className="text-lg font-semibold">
              <div className='flex justify-between items-center gap-4'>
                <span>IP Address: {props.ip?.ip || 'N/A'}</span>
                <span className='text-sm text-muted-foreground'>Detected Accounts: {props.ip?.count || 0}</span>
              </div>
            </DialogTitle>
          </DialogHeader>
          <div className='p-3 rounded-lg border border-amber-200 bg-amber-50'>
                <p className='text-sm text-amber-900'>
                  <span className='font-semibold'>{FRAUDSCRUB_CONSTANTS.th_ip}:</span> {props.ip?.ip}
                </p>
              </div>
            <div className='h-full space-y-4 overflow-auto'>
              {props.fraudUsers &&
                props.fraudUsers !== undefined &&
                Array.isArray(props.fraudUsers) &&
                props.fraudUsers.length > 0 ?
                <div className="relative rounded-lg border bg-muted/30">
                  <TableToolbar
                    columns={allColumns}
                    onToggle={toggleVisibility}
                    onReorder={reorder}
                    onReset={resetToDefault}
                  />
                  <Table>
                    <TableHeader>
                      <TableRow>
                        {visibleIndices.map((origIdx) => (
                          <TableHead key={origIdx} className="whitespace-nowrap">{maxipHeaders[origIdx]}</TableHead>
                        ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {props.fraudUsers &&
                        props.fraudUsers !== undefined &&
                        Array.isArray(props.fraudUsers) &&
                        props.fraudUsers.length > 0 ? (
                        props.fraudUsers.map((item, ind) => (
                          <TableRow key={generateKey(ind)}>
                            {visibleIndices.map((origIdx) => (
                              <TableCell key={origIdx} className={origIdx === 0 ? 'text-sm font-medium whitespace-nowrap' : 'text-sm whitespace-nowrap'}>
                                {maxipRowAccessors[origIdx](item)}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      ) : (
                        <NoDataFound colspan={visibleIndices.length} text="No results found" />
                      )}
                    </TableBody>
                  </Table>
                </div> : <Skelton hLen={4} vLen={3} />
              }
            </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MaxipDialog;
